import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { GetCommonSettings } from '../../common/data';
import Modal from '../../common/modal';
import jQuery from 'jquery';
const PalletModal = ({ openPallet = false, openBreakingPallet = false, openTipping = false, setOpenPallet, setOpenBreakingPallet, setOpenTipping, }) => {
    const [pallet, setPallet] = useState(false);
    const [breakingPallet, setBreakingPallet] = useState(false);
    const [tipping, setTipping] = useState(false);
    const settings = GetCommonSettings();
    useEffect(() => {
        if (!setOpenBreakingPallet) {
            jQuery('.breaking-pallet-info').on('click', () => {
                setBreakingPallet(true);
            });
        }
        if (!setOpenPallet) {
            jQuery('.pallet-info').on('click', () => {
                setPallet(true);
            });
        }
        if (!setOpenTipping) {
            jQuery('.tipping-info').on('click', () => {
                setTipping(true);
            });
        }
    }, [setOpenBreakingPallet, setOpenPallet, setOpenTipping]);
    return (_jsxs(_Fragment, { children: [_jsx(Modal, Object.assign({ title: settings.pallet_cost.title, open: pallet || openPallet, onClose: () => {
                    setPallet(false);
                    setOpenPallet === null || setOpenPallet === void 0 ? void 0 : setOpenPallet(false);
                } }, { children: _jsx("div", { dangerouslySetInnerHTML: {
                        __html: settings.pallet_cost.description,
                    } }) })), _jsx(Modal, Object.assign({ title: settings.pallet_breaking_cost.title, open: breakingPallet || openBreakingPallet, onClose: () => {
                    setBreakingPallet(false);
                    setOpenBreakingPallet === null || setOpenBreakingPallet === void 0 ? void 0 : setOpenBreakingPallet(false);
                } }, { children: _jsx("div", { dangerouslySetInnerHTML: {
                        __html: settings.pallet_breaking_cost.description,
                    } }) })), _jsx(Modal, Object.assign({ title: settings.tipping_cost.title, open: tipping || openTipping, onClose: () => {
                    setTipping(false);
                    setOpenTipping === null || setOpenTipping === void 0 ? void 0 : setOpenTipping(false);
                } }, { children: _jsx("div", { dangerouslySetInnerHTML: {
                        __html: settings.tipping_cost.description,
                    } }) }))] }));
};
export default PalletModal;
